import { useState, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Navbar, Nav, Container } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import logo from '../assets/img/logo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/github7.png';
import { HashLink } from 'react-router-hash-link';
import { Link } from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const { t, language, toggleLanguage } = useLanguage();

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>{t('nav').home}</Nav.Link>
              <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>{t('nav').skills}</Nav.Link>
              <Nav.Link href="#project" className={activeLink === 'project' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('project')}>{t('nav').projects}</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href={t('footer').linkedin || "https://www.linkedin.com/in/jonas-ojeda-18308a1ab/"} target='_blank'><img src={navIcon1} alt="LinkedIn" /></a>
                <a href={t('footer').github || "https://github.com/jonasojeda"} target='_blank'><img src={navIcon2} alt="GitHub" /></a>
              </div>
              <HashLink to='#connect'>
                <button className="vvd"><span>{t('nav').connect}</span></button>
              </HashLink>
              <button 
                onClick={toggleLanguage} 
                style={{
                  background: 'transparent',
                  color: 'white',
                  border: '1px solid white',
                  padding: '8px 12px',
                  marginLeft: '15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                {language === 'es' ? 'EN' : 'ES'}
              </button>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}
